import * as React from 'react';

import { flowRight } from 'lodash';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import pendo, { LEARNER_API_KEY } from 'js/lib/pendo';
import Retracked from 'js/lib/retracked';
import user from 'js/lib/user';

type Props = {};

export const AccountProfileApp = ({ children }: React.PropsWithChildren<Props>) => {
  React.useEffect(() => {
    const { external_id: externalId } = user.get();
    pendo.init(
      {
        visitor: {
          id: externalId,
        },
      },
      LEARNER_API_KEY
    );
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
};

export default flowRight(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'account_profile',
        page: 'account_profile',
      },
    };
  }),
  connectToStores(['ApplicationStore'], (context, props) => {
    return {
      ...props,
      csrfToken: context.ApplicationStore.getState().csrfToken,
      requestCountryCode: context.ApplicationStore.getState().requestCountryCode,
    };
  })
)(AccountProfileApp);
